<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/stock/bills/index' }">出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>跨公司调拨</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="发起跨公司调拨" name="save" :disabled="isReceiveMode">
        <template v-if="!isReceiveMode">
          <el-alert v-if="lastSavedBillCode" type="success" :closable="false" show-icon>
            <template #title>
              申请成功，来源出库单号：
              <el-link type="success" :underline="false" @click="openReceiveBySource(lastSavedBillCode)">{{
                lastSavedBillCode }}</el-link>
            </template>
          </el-alert>

          <el-form :model="saveForm" label-width="130px" class="search-form" style="margin-top: 10px;">
            <el-row>
              <el-form-item label="来源公司" required>
                <el-tree-select v-model="saveForm.companyID" :data="sourceCompanys" check-strictly
                  :render-after-expand="false" :disabled="saveBounds.length > 0" style="width: 220px" />
              </el-form-item>
              <el-form-item label="接收方公司" required>
                <el-tree-select v-model="saveForm.targetCompanyID" :data="targetCompanys" check-strictly
                  :render-after-expand="false" style="width: 220px" />
              </el-form-item>

              <el-form-item label="出库单号" required>
                <el-input v-model="saveForm.billCode" disabled style="width: 220px" />
              </el-form-item>
              <el-form-item label="单据类型">
                <el-input :model-value="saveForm.billType" disabled style="width: 220px" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :xs="18" :sm="20" :md="22">
                <el-form-item label="备注">
                  <el-input v-model="saveForm.remark" type="textarea" :rows="2" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="toolbar">
            <el-button type="primary" plain icon="Plus" @click="openAddSaveDialog">添加出库货品</el-button>
            <el-button plain icon="Refresh" @click="refreshBillCode">重置单号</el-button>
            <el-button type="danger" plain icon="Delete" @click="saveBounds = []"
              :disabled="saveBounds.length === 0">清空明细</el-button>
          </div>

          <el-table :data="saveBounds" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" width="55" align="center" />
            <el-table-column prop="detailCode" label="系统款号" width="130" />
            <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
            <el-table-column prop="serialCode" label="批次号" width="130" />
            <el-table-column prop="storeCode" label="库房" width="90" />
            <el-table-column prop="channel" label="渠道" width="100" />
            <el-table-column label="转移数量" width="110" align="center">
              <template #default="scope">
                <el-input v-model.number="scope.row.stockNumber" type="number" min="1" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="stockRemain" label="可用库存" width="90" align="center" />
            <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
            <el-table-column prop="productPrice" label="入库价" width="90" align="right" />
            <el-table-column label="操作" width="80" align="center">
              <template #default="scope">
                <el-button type="primary" link size="small" @click="removeSaveBound(scope.row)">[删除]</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="summary-row">来源库存合计金重：{{ saveGoldWeightTotal.toFixed(2) }} g</div>

          <div class="submit-row">
            <el-button type="primary" icon="Check" :loading="saveLoading" @click="submitSave">提交出库</el-button>
          </div>

          <el-dialog title="新增出库货品" v-model="showAddDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
            <el-form :model="searchForm" label-width="110px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="货品批次号">
                    <el-input v-model="searchForm.serialCode" placeholder="请输入批次号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="系统款号">
                    <el-input v-model="searchForm.detailCode" placeholder="请输入系统款号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="品牌款号">
                    <el-input v-model="searchForm.brandModelCode" placeholder="请输入品牌款号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出库公司">
                    <el-tree-select v-model="saveForm.companyID" :data="sourceCompanys" clearable check-strictly
                      :render-after-expand="false" style="width: 100%" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来源库房">
                    <el-select v-model="searchForm.storeCode" placeholder="请选择库房" clearable style="width: 100%">
                      <el-option v-for="item in dict.stores" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来源渠道">
                    <el-select v-model="searchForm.channel" placeholder="请选择渠道" clearable style="width: 100%">
                      <el-option v-for="item in dict.channels" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24" style="text-align: center;">
                  <el-button type="primary" icon="Search" @click="searchSaveStock"
                    :loading="searchLoading">查询货品</el-button>
                  <el-button @click="resetSaveSearchForm">重置</el-button>
                </el-col>
              </el-row>
            </el-form>

            <el-divider></el-divider>

            <el-table :data="searchResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
              v-loading="searchLoading">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                show-overflow-tooltip></el-table-column>
              <el-table-column prop="detailName" label="货品名称" min-width="140" show-overflow-tooltip></el-table-column>
              <el-table-column prop="storeCode" label="库房" width="90" align="center"></el-table-column>
              <el-table-column prop="channel" label="渠道" width="90" align="center"></el-table-column>
              <el-table-column prop="stockRemain" label="可用库存" width="90" align="right"></el-table-column>
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
              <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right"></el-table-column>
              <el-table-column prop="productPrice" label="入库价" width="90" align="right"></el-table-column>
              <el-table-column label="操作" width="80" align="center" fixed="right">
                <template #default="scope">
                  <el-button type="primary" link size="small" @click="addSaveBound(scope.row)">添加</el-button>
                </template>
              </el-table-column>
            </el-table>

            <template #footer>
              <span class="dialog-footer">
                <el-button @click="showAddDialog = false">取消</el-button>
              </span>
            </template>
          </el-dialog>
        </template>

      </el-tab-pane>

      <el-tab-pane label="跨公司调拨详情" name="receive" :disabled="!isReceiveMode">
        <template v-if="isReceiveMode">
          <el-form :inline="true" class="search-form">
            <el-form-item label="来源出库单号">
              <el-input v-model="sourceBillCode" placeholder="请输入来源出库单号" style="width: 260px" clearable
                @keyup.enter="loadBySourceBillCode" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="Search" @click="loadBySourceBillCode">查询</el-button>
            </el-form-item>
          </el-form>

          <el-tabs v-model="receiveSubTab" class="receive-sub-tabs">
            <el-tab-pane label="来源出库信息" name="source">
              <el-descriptions border :column="4" size="small" v-if="sourceBill">
                <el-descriptions-item label="来源出库单号">{{ sourceBill.billCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源公司">{{ companyName(sourceBill.companyID) }}</el-descriptions-item>
                <el-descriptions-item label="接收公司">{{ companyName(sourceBill.targetCompanyID || sourceBill.netCode)
                  }}</el-descriptions-item>
                <el-descriptions-item label="来源库房">{{ sourceBill.storeCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源渠道">{{ sourceBill.channelCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="单据类型">{{ sourceBill.billType || '-' }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ statusText(sourceBill.status) }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ sourceBill.remark || '-' }}</el-descriptions-item>
              </el-descriptions>

              <el-table :data="sourceBounds" stripe border size="small" style="width: 100%; margin-top: 12px;">
                <el-table-column type="index" label="序号" width="55" align="center" />
                <el-table-column prop="detailCode" label="系统款号" width="130" />
                <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column prop="serialCode" label="批次号" width="130" />
                <el-table-column prop="storeCode" label="来源库房" width="100" />
                <el-table-column prop="channel" label="来源渠道" width="100" />
                <el-table-column prop="stockNumber" label="来源出库数量" width="120" align="center" />
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                <el-table-column prop="productPrice" label="入库价" width="90" align="right" />
              </el-table>

              <div class="summary-row">明细合计金重：{{ sourceGoldWeightTotal.toFixed(2) }} g</div>
            </el-tab-pane>

            <el-tab-pane label="接收公司入库" name="receive">
              <el-descriptions border :column="3" size="small" style="margin-bottom: 10px;">
                <el-descriptions-item label="来源申请单号">{{ sourceBillCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="预期接收单号">{{ expectedReceiveBillCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="处理方式">全部接收</el-descriptions-item>
              </el-descriptions>

              <el-table :data="receiveBounds" stripe border size="small" style="width: 100%">
                <el-table-column type="index" label="序号" width="55" align="center" />
                <el-table-column prop="detailCode" label="系统款号" width="130" />
                <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column prop="serialCode" label="批次号" width="130" />
                <el-table-column prop="stockNumber" label="接收入库数量" width="120" align="center" />
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                <el-table-column prop="productPrice" label="入库价" width="90" align="right" />
                <el-table-column prop="sourceStockNumber" label="来源出库数量" width="120" align="center" />
              </el-table>
              <div class="summary-row">明细合计金重：{{ sourceGoldWeightTotal.toFixed(2) }} g</div>

              <el-divider v-if="!hasReceived"></el-divider>

              <div class="submit-row" v-if="!hasReceived">
                <el-button type="primary" icon="Check" :loading="receiveLoading" @click="submitReceive">确认接收</el-button>
              </div>

              <template v-if="hasReceived">
                <el-divider>接收结果</el-divider>
                <el-descriptions border :column="4" size="small" v-if="receiveBill">
                  <el-descriptions-item label="接收入库单号">{{ receiveBill.billCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="接收公司">{{ companyName(receiveBill.companyID) }}</el-descriptions-item>
                  <el-descriptions-item label="关联来源单">{{ receiveBill.sourceBillCode || receiveBill.netCode || '-'
                    }}</el-descriptions-item>
                  <el-descriptions-item label="状态">{{ statusText(receiveBill.status) }}</el-descriptions-item>
                  <el-descriptions-item label="接收库房">{{ receiveBill.storeCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="接收渠道">{{ receiveBill.channelCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="单据类型">{{ receiveBill.billType || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="备注">{{ receiveBill.remark || '-' }}</el-descriptions-item>
                </el-descriptions>

                <el-table :data="receiveResultBounds" stripe border size="small" style="width: 100%; margin-top: 12px;">
                  <el-table-column type="index" label="序号" width="55" align="center" />
                  <el-table-column prop="detailCode" label="系统款号" width="130" />
                  <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                  <el-table-column prop="serialCode" label="批次号" width="130" />
                  <el-table-column prop="storeCode" label="接收库房" width="100" />
                  <el-table-column prop="channel" label="接收渠道" width="100" />
                  <el-table-column prop="stockNumber" label="接收入库数量" width="120" align="center" />
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                  <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                  <el-table-column prop="productPrice" label="入库价" width="90" align="right" />
                </el-table>

                <div class="summary-row">接收公司入库合计金重：{{ receiveGoldWeightTotal.toFixed(2) }} g</div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import {
  fetchBillCode,
  fetchBillByCode,
  fetchGroupBySerialCode,
  submitCrossTransferReceive,
  submitCrossTransferSave,
} from "@/api/stock";
import { getCompanyTreeAll } from "@/api/basic";

export default {
  name: "CrossTransfer",
  data() {
    return {
      activeTab: "save",
      receiveSubTab: "receive",
      saveLoading: false,
      receiveLoading: false,
      sourceCompanys: [],
      targetCompanys: [],
      companyMap: {},
      dict: { stores: [], channels: [] },
      showAddDialog: false,
      searchLoading: false,
      searchResults: [],
      searchForm: {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: "",
      },
      saveBounds: [],
      lastSavedBillCode: "",
      sourceBillCode: "",
      sourceBill: null,
      sourceBounds: [],
      receiveBill: null,
      receiveResultBounds: [],
      receiveBounds: [],
      saveForm: {
        companyID: "",
        billCode: "",
        billType: "跨公司调拨出库",
        targetCompanyID: "",
        remark: "",
      },
    };
  },
  computed: {
    isReceiveMode() {
      const query = this.$route.query || {};
      return !!(query.billCode || "").trim();
    },
    saveGoldWeightTotal() {
      return this.saveBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    sourceGoldWeightTotal() {
      return this.sourceBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    receiveGoldWeightTotal() {
      return this.receiveResultBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    hasReceived() {
      return this.receiveResultBounds.length > 0;
    },
    expectedReceiveBillCode() {
      return this.sourceBillCode ? `${this.sourceBillCode}-R` : "";
    },
  },
  methods: {
    statusText(status) {
      if (status === -1) return "已取消";
      if (status === 0) return "待审核";
      if (status === 1) return "已审核";
      if (status === 2) return "已完成";
      return status == null ? "-" : String(status);
    },
    companyName(companyID) {
      return this.companyMap[companyID] || companyID || "-";
    },
    getRouteBillCode() {
      const query = this.$route.query || {};
      return (query.billCode || "").trim().replace(/-R$/i, "");
    },
    openReceiveBySource(sourceBillCode) {
      const billCode = (sourceBillCode || "").trim();
      if (!billCode) return;
      this.$router.push({ path: "/stock/bills/crossTransfer", query: { billCode } });
    },
    syncFromRoute() {
      const query = this.$route.query || {};
      const billCode = (query.billCode || "").trim();

      if (billCode) {
        this.activeTab = "receive";
        this.receiveSubTab = "receive";
        this.sourceBillCode = billCode.replace(/-R$/i, "") || billCode;
        if (this.sourceBillCode) this.loadBySourceBillCode();
      } else {
        this.activeTab = "save";
        this.receiveSubTab = "receive";
        this.sourceBillCode = "";
        this.sourceBill = null;
        this.sourceBounds = [];
        this.receiveBill = null;
        this.receiveResultBounds = [];
        this.receiveBounds = [];
        this.refreshBillCode();
      }
    },
    refreshBillCode(force = false) {
      const routeBillCode = this.getRouteBillCode();
      if (!force && routeBillCode) {
        this.saveForm.billCode = routeBillCode;
        return Promise.resolve(routeBillCode);
      }

      return fetchBillCode({ billType: "跨公司调拨出库", prev: "CKDB" }).then((res) => {
        this.saveForm.billCode = res.data || "";
      });
    },
    openAddSaveDialog() {
      if (!this.saveForm.companyID) {
        this.$message({ type: "warning", message: "请选择来源公司" });
        return;
      }

      this.showAddDialog = true;
      this.searchResults = [];
      this.resetSaveSearchForm();
    },
    resetSaveSearchForm() {
      this.searchForm = {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: "",
      };
      this.searchResults = [];
    },
    searchSaveStock() {
      if (!this.saveForm.companyID) {
        this.$message({ type: "warning", message: "请先选择来源公司" });
        return;
      }
      if (!this.searchForm.serialCode && !this.searchForm.detailCode && !this.searchForm.brandModelCode
        && !this.searchForm.storeCode && !this.searchForm.channel) {
        this.$message({ type: "warning", message: "请至少填写一个查询条件" });
        return;
      }

      this.searchLoading = true;
      this.searchResults = [];

      const serialCodes = [];
      if (this.searchForm.serialCode) {
        const codes = this.searchForm.serialCode.split(',').map((code) => code.trim()).filter((code) => code);
        serialCodes.push(...codes);
      }

      fetchGroupBySerialCode(
        serialCodes,
        this.saveForm.companyID || "",
        this.searchForm.detailCode || "",
        this.searchForm.storeCode || "",
        this.searchForm.channel || "",
        this.searchForm.brandModelCode || ""
      ).then((res) => {
        this.searchLoading = false;
        if (res.code === 200) {
          const rows = (res.data || []).filter((item) => Number(item.stockRemain || 0) > 0);
          this.searchResults = rows;
          if (rows.length === 0) {
            this.$message({ type: "info", message: "未找到符合条件的来源库存" });
          }
        } else {
          this.$message({ type: "error", message: res.content || res.message || "查询失败" });
        }
      }).catch(() => {
        this.searchLoading = false;
        this.$message({ type: "error", message: "查询失败，请稍后重试" });
      });
    },
    addSaveBound(item) {
      const id = item.id || item.ID || "";
      const serialCode = item.serialCode || item.SerialCode || "";
      const uniqueKey = id || serialCode;
      if (!uniqueKey) {
        this.$message({ type: "warning", message: "数据不完整，无法添加" });
        return;
      }
      if (this.saveBounds.some((row) => (row.id || row.serialCode) === uniqueKey)) {
        this.$message({ type: "warning", message: "该货品已添加，请勿重复添加" });
        return;
      }

      this.saveBounds.push({
        id,
        companyID: item.companyID || item.companyId || this.saveForm.companyID,
        storeCode: item.storeCode || "",
        channel: item.channel || item.channelCode || "",
        detailID: item.detailID || item.detailId || "",
        detailCode: item.detailCode || "",
        detailName: item.detailName || "",
        serialCode,
        brandSerialCode: item.brandSerialCode || "",
        brandCode: item.brandCode || "",
        brandModelCode: item.brandModelCode || "",
        stockNumber: 1,
        stockRemain: Number(item.stockRemain || item.stockNumber || 0),
        weight: Number(item.weight || 0),
        goldWeight: Number(item.goldWeight || 0),
        productPrice: Number(item.productPrice || 0),
      });

      this.$message({ type: "success", message: "添加成功" });

      this.searchResults = this.searchResults.filter((row) => {
        const rowKey = (row.id || row.ID || row.serialCode || row.SerialCode || "");
        return rowKey !== uniqueKey;
      });
    },
    removeSaveBound(row) {
      this.saveBounds = this.saveBounds.filter((item) => (item.id || item.serialCode) !== (row.id || row.serialCode));
    },
    validateSave() {
      if (!this.saveForm.companyID || !this.saveForm.targetCompanyID || !this.saveForm.billCode) {
        return "请完整填写原公司出库单必填字段";
      }
      if (this.saveForm.companyID === this.saveForm.targetCompanyID) {
        return "跨公司调拨时来源公司与接收公司不能相同";
      }
      if (this.saveBounds.length === 0) {
        return "请至少添加一条来源库存明细";
      }
      for (let i = 0; i < this.saveBounds.length; i++) {
        const row = this.saveBounds[i];
        if (!row.id) return `${i + 1}行 来源库存ID缺失`;
        if (!row.stockNumber || Number(row.stockNumber) <= 0) return `${i + 1}行 转移数量必须大于0`;
        if (Number(row.stockRemain) > 0 && Number(row.stockNumber) > Number(row.stockRemain)) {
          return `${i + 1}行 转移数量超过可用库存`;
        }
      }
      return "";
    },
    submitSave() {
      const msg = this.validateSave();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }

      const payload = {
        bill: {
          companyID: this.saveForm.companyID,
          billCode: this.saveForm.billCode,
          billType: this.saveForm.billType,
          storeCode: "",
          channelCode: "",
          remark: this.saveForm.remark,
        },
        bounds: this.saveBounds.map((item) => ({
          id: item.id,
          companyID: item.companyID || this.saveForm.companyID,
          storeCode: item.storeCode,
          channel: item.channel,
          detailID: item.detailID,
          detailCode: item.detailCode,
          detailName: item.detailName,
          serialCode: item.serialCode,
          brandSerialCode: item.brandSerialCode,
          brandCode: item.brandCode,
          brandModelCode: item.brandModelCode,
          stockNumber: Number(item.stockNumber || 0),
          goldWeight: Number(item.goldWeight || 0),
          productPrice: Number(item.productPrice || 0),
        })),
      };

      const firstBound = this.saveBounds[0] || {};
      payload.bill.storeCode = firstBound.storeCode || "";
      payload.bill.channelCode = firstBound.channel || firstBound.channelCode || "";

      this.saveLoading = true;
      submitCrossTransferSave(payload, this.saveForm.targetCompanyID)
        .then((res) => {
          this.$message({ type: res.type || "success", message: res.content || "出库提交成功" });
          if (res.code === 200) {
            this.lastSavedBillCode = (res.data && (res.data.sourceBillCode || res.data.billCode)) || this.saveForm.billCode;
            this.saveBounds = [];
            this.saveForm.remark = "";
            this.refreshBillCode(true);
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    async loadBySourceBillCode() {
      this.sourceBillCode = (this.sourceBillCode || "").trim().replace(/-R$/i, "");
      if (!this.sourceBillCode) {
        this.$message({ type: "warning", message: "请输入来源出库单号" });
        return;
      }

      this.sourceBill = null;
      this.sourceBounds = [];
      this.receiveBill = null;
      this.receiveResultBounds = [];
      this.receiveBounds = [];

      const sourceRes = await fetchBillByCode(this.sourceBillCode);
      if (sourceRes.code !== 200 || !sourceRes.data || !sourceRes.data.bill) {
        this.$message({ type: "warning", message: sourceRes.content || "未查询到数据" });
        return;
      }

      this.sourceBill = sourceRes.data.bill;
      const sourceRows = (sourceRes.data.prebounds && sourceRes.data.prebounds.length > 0)
        ? sourceRes.data.prebounds
        : (sourceRes.data.bounds || []);

      this.sourceBounds = sourceRows.map((item) => ({
        id: item.id || item.ID,
        detailID: item.detailID,
        detailCode: item.detailCode,
        detailName: item.detailName,
        serialCode: item.serialCode,
        storeCode: item.storeCode,
        channel: item.channel || item.channelCode,
        brandSerialCode: item.brandSerialCode,
        brandCode: item.brandCode,
        brandModelCode: item.brandModelCode,
        stockNumber: Number(item.stockNumber || 0),
        goldWeight: Number(item.goldWeight || 0),
        productPrice: Number(item.productPrice || 0),
      }));

      const sourceStockMap = {};
      this.sourceBounds.forEach((item) => {
        const key = `${item.id || ""}_${item.serialCode || ""}`;
        sourceStockMap[key] = Number(item.stockNumber || 0);
      });

      this.receiveBounds = this.sourceBounds.map((item) => ({
        ...item,
        sourceStockNumber: Number(item.stockNumber || 0),
      }));

      const receiveRes = await fetchBillByCode(this.expectedReceiveBillCode);
      if (receiveRes.code === 200 && receiveRes.data && receiveRes.data.bill) {
        const preRows = receiveRes.data.prebounds || [];
        const boundRows = receiveRes.data.bounds || [];

        if (preRows.length > 0) {
          this.receiveBounds = preRows.map((item) => {
            const key = `${item.id || item.ID || ""}_${item.serialCode || ""}`;
            const sourceStockNumber = sourceStockMap[key] != null
              ? sourceStockMap[key]
              : Number(item.sourceStockNumber || item.stockNumber || 0);
            return {
              id: item.id || item.ID,
              detailCode: item.detailCode,
              detailName: item.detailName,
              serialCode: item.serialCode,
              storeCode: item.storeCode,
              channel: item.channel || item.channelCode,
              stockNumber: Number(item.stockNumber || 0),
              goldWeight: Number(item.goldWeight || 0),
              productPrice: Number(item.productPrice || 0),
              sourceStockNumber,
            };
          });
        }

        this.receiveResultBounds = boundRows.map((item) => ({
          detailCode: item.detailCode,
          detailName: item.detailName,
          serialCode: item.serialCode,
          storeCode: item.storeCode,
          channel: item.channel,
          stockNumber: Number(item.stockNumber || 0),
          goldWeight: Number(item.goldWeight || 0),
          productPrice: Number(item.productPrice || 0),
        }));

        this.receiveBill = boundRows.length > 0 ? receiveRes.data.bill : null;
      }
    },
    validateReceive() {
      if (!this.sourceBill || !this.sourceBill.billCode) return "请先查询来源出库单";
      if (!this.sourceBillCode) return "来源单号不能为空";
      return "";
    },
    submitReceive() {
      const msg = this.validateReceive();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }

      this.$confirm(`确认接收来源出库单【${this.sourceBillCode}】吗？`, "确认接收", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.receiveLoading = true;
        submitCrossTransferReceive(this.sourceBillCode)
          .then((res) => {
            this.$message({ type: res.type || "success", message: res.content || "确认接收成功" });
            if (res.code === 200) {
              const data = res.data || {};
              this.receiveBill = {
                ...this.receiveBill,
                ...data,
                billCode: data.billCode || this.expectedReceiveBillCode,
                sourceBillCode: data.sourceBillCode || this.sourceBillCode,
                status: data.status == null ? 2 : data.status,
              };
              this.loadBySourceBillCode();
            }
          })
          .finally(() => {
            this.receiveLoading = false;
          });
      }).catch(() => { });
    },
  },
  async created() {
    this.sourceCompanys = await this.$kaung.companys() || [];
    const companyTreeRes = await getCompanyTreeAll();
    this.targetCompanys = (companyTreeRes && companyTreeRes.code === 200) ? (companyTreeRes.data || []) : [];

    const stack = [...this.targetCompanys];
    while (stack.length > 0) {
      const item = stack.pop();
      if (!item) continue;
      const key = item.value || item.id;
      const name = item.label || item.companyName || item.name;
      if (key) this.companyMap[key] = name;
      if (item.children && item.children.length > 0) stack.push(...item.children);
    }

    this.saveForm.companyID = (this.$store.getters.getUserInfo || {}).companyID || "";
    this.$kaung.dictionary("stock", "store").then((res) => (this.dict.stores = res));
    this.$kaung.dictionary("stock", "channel").then((res) => (this.dict.channels = res));

    this.syncFromRoute();
  },
  watch: {
    '$route': {
      handler() {
        this.syncFromRoute();
      },
      deep: true,
    }
  }
};
</script>

<style lang="less" scoped>
.summary-row {
  margin-top: 10px;
  text-align: right;
  font-weight: 600;
}

.submit-row {
  margin-top: 14px;
  text-align: center;
}
</style>
